import React from 'react';
import { useNavigate } from "react-router-dom";
import loader from "../../assets/Images/loader.gif";
import { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";


const MaterialConsumeStatus = () => {
    // const [loading, setLoading] = useState(false);
    const [consumStatus, setConsumStatus] = useState([]);
    const [consumItem, setConsumItem] = useState([]);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [activeForm, setActiveForm] = useState("form1");

    const [editForm, setEditForm] = useState({
        quantity: "",
        serialNo: ""
    });

    const navigate = useNavigate();
    const redirectYourAssignmentAddItem = () => {
        navigate("/yourAssignmentAddItem");
    }
    const redirectFaultRepairAssignments = () => {
        navigate("/dashboard");
    }

    const handleMaterialConsumeNext = () => {
        navigate("/materialConsumeNext");
    }
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [equipment, setEquipment] = useState([]);
    const [masterStatus, setMasterStatus] = useState("");

    // State for showing the Edit Modal and keeping track of the card being edited
    const [editModal, setEditModal] = useState(false);
    const [selectedCard, setSelectedCard] = useState(null);

    // States for drop-down options (fetched from APIs)
    const [optionItem, setOptionItem] = useState([]);
    const [optionSubItem, setOptionSubItem] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);

    // States for form values in the modal
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedSubItem, setSelectedSubItem] = useState(null);
    const [addItemData, setAddItemData] = useState({
        quantity: "",
        serialNo: "",
        FaultyDevice: "",
    });
    const [adaptor, setAdaptor] = useState(null);
    const [reasonOfReplacement, setReasonOfReplacement] = useState(null);
    const [locationCode, setLocationCode] = useState(null);

    // react-select styling (adjust as needed)
    const style1 = {
        control: (provided) => ({ ...provided, minHeight: "30px", height: "30px" }),
        indicatorsContainer: (provided) => ({ ...provided, height: "30px" }),
    };

    // Fetch material consumption data on mount
    const fetchData = async () => {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            Action: "getMaterialconsumption",
            srNumber: sessionStorage.getItem("ViewSR"),
            canID: sessionStorage.getItem("CanId"),
            master: "false",
        };

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });
            const result = await response.json();
            if (result && result.Status === "Success" && result.Response) {
                setItems(result.Response.item || []);
                setEquipment(result.Response.equipment || []);
                setMasterStatus(result.Response.MasterStatus || "");
            } else {
                toast.warning(result?.Response?.Message || "Error fetching data", {
                    autoClose: 1500,
                });
            }
        } catch (error) {
            toast.error("Error fetching data");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {

        fetchData();
    }, []);

    // Fetch item master options for the Item and Sub Item dropdown
    useEffect(() => {
        const fetchItemOptions = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_API_URL, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        Action: "getAllItemMasterFromCRM",
                        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                        // CanId: "9060885",
                        CanId: sessionStorage.getItem("CanId"),
                        Master: "true",
                        SrNumber: sessionStorage.getItem("ViewSR"),
                    }),
                });
                const result = await response.json();
                if (result && result.Status === 1 && result.Response?.item) {
                    // Remove duplicates based on item_code
                    const itemsData = result.Response.item;
                    const uniqueItems = Array.from(
                        new Map(itemsData.map((item) => [item.item_code, item])).values()
                    );
                    setOptionItem(uniqueItems);
                } else {
                    toast.warning("No item data available", { autoClose: 1500 });
                }
            } catch (error) {
                toast.error("Error fetching item options");
            }
        };
        fetchItemOptions();
    }, []);

    // Fetch location options for the Location Code dropdown
    useEffect(() => {
        const fetchLocationOptions = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_API_URL, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                        Action: "getLocationCode",
                    }),
                });
                const result = await response.json();
                if (result && result.Status === "Success" && result.Response?.Data) {
                    setLocationOptions(result.Response.Data);
                } else {
                    toast.warning("No location data", { autoClose: 1500 });
                }
            } catch (error) {
                toast.error("Error fetching location options");
            }
        };
        fetchLocationOptions();
    }, []);

    // When an item is selected, update the sub-item dropdown options
    const handleItem = (selectedOption) => {
        setSelectedItem(selectedOption);
        // Filter optionSubItem from optionItem array (all entries with the selected item_code)
        const filteredSubItems = optionItem.filter(
            (item) => item.item_code === selectedOption.value
        );
        setOptionSubItem(filteredSubItems);
        setSelectedSubItem(null);
    };

    const handleSubItem = (selectedOption) => {
        setSelectedSubItem(selectedOption);
    };

    const handleAdaptor = (selectedOption) => {
        setAdaptor(selectedOption);
    };

    const handleReasonOfReplacement = (selectedOption) => {
        setReasonOfReplacement(selectedOption);
    };

    const handleLocationChange = (selectedOption) => {
        setLocationCode(selectedOption);
    };

    // For handling text input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setAddItemData((prev) => ({ ...prev, [name]: value }));
    };

    // Open the Edit Modal and pre-populate form fields from the card data
    const openEditModal = (data) => {
        setSelectedCard(data);
        setAddItemData({
            quantity: data.Quantity || "",
            serialNo: data.SerialNumber || "",
            FaultyDevice: data.OldFaultyDeviceSerailNo || "",
        });
        // Reset dropdowns (user must select new values)
        setSelectedItem(null);
        setSelectedSubItem(null);
        setAdaptor(null);
        setReasonOfReplacement(null);
        setLocationCode(null);
        setEditModal(true);
    };

    // Handle the update API call when Update button is clicked in the form
    const handleUpdate = async (e) => {
        e.preventDefault();
        if (!selectedCard) {
            toast.warning("No card selected");
            return;
        }
        if (!selectedItem || !selectedSubItem) {
            toast.warning("Please select both Item and Sub Item");
            return;
        }
        if (!addItemData.quantity || !addItemData.serialNo) {
            toast.warning("Enter Quantity and Serial No.");
            return;
        }
        if (!locationCode || !adaptor || !reasonOfReplacement) {
            toast.warning("Please select Location Code, Adaptor and Reason");
            return;
        }

        // Construct payload per API specification
        const payload = {
            Action: "editItemCRM",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            ItemID: selectedCard.ItemconsumptionID, // from the card
            Item: selectedItem.value, // item_code of selected item
            SubItem: selectedSubItem.value, // sub_item_code of selected sub item
            SerialNumber: addItemData.serialNo,
            Quantity: addItemData.quantity,
            LocationCode: locationCode.value, // from dropdown
            Adapter: adaptor.value, // from dropdown
            Reasonofreplacement: reasonOfReplacement.value, // from dropdown
            Oldfaultydevice: addItemData.FaultyDevice,
        };

        try {
            const response = await fetch(process.env.REACT_APP_API_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            const result = await response.json();
            if (result && result.Status === "Success") {
                toast.success("Updated successfully", { autoClose: 1500 });
                setEditModal(false);
                fetchData();
            } else {
                toast.error(result?.Response?.Message || "Update failed", { autoClose: 1500 });
            }
        } catch (error) {
            toast.error("Error updating");
        }
    };

    const highlightStyle = {
        backgroundColor: "#f5e6e6", // Light red/pinkish background to highlight
        border: "1px solid #ffcccc", // Subtle border to emphasize the card
        padding: "10px",
        borderRadius: "5px",
    };

    // Render a card with an Edit button
    const renderCard = (data) => (
        <div
            className="card mb-3"
            style={data.ItemStatus === "Consumption Failed" ? highlightStyle : {}}
        >
            <div className="m-3 card-data">
                <p className="card-text" style={{ fontSize: "20px" }}>
                    Master Status: {masterStatus}
                    <br />
                    Item Code: {data.Itemcode}
                    <br />
                    Item Name: {data.ItemName}
                    <br />
                    Serial Number: {data.SerialNumber}
                    <br />
                    Quantity: {data.Quantity}
                    <br />
                    Consumption Type: {data.ConsumptionType}
                    <br />
                    Item Status: {data.ItemStatus}
                    <br />
                    <br />
                    {data.ReasonofReplacement && (
                        <div >
                            <h2 className="text-lg font-semibold mb-2">Replaced Item Details Below:</h2>
                            {data.ReasonofReplacement && (
                                <>
                                    Reason of Replacement: {data.ReasonofReplacement}
                                    <br />
                                </>
                            )}

                            {data.ReplacementItemName && (
                                <>
                                    Replacement Item Name: {data.ReplacementItemName}
                                    <br />
                                </>
                            )}

                            {data.ReplacementItemCode && (
                                <>
                                    Replacement Item Code: {data.ReplacementItemCode}
                                    <br />
                                </>
                            )}

                            {data.OldFaultyDeviceSerailNo && (
                                <>
                                    Old Faulty Device Serial No: {data.OldFaultyDeviceSerailNo}
                                </>
                            )}
                        </div>
                    )}

                </p>
                {/* Show Edit button only if ItemStatus is 'Consumption Failed' */}
                {data.ItemStatus === "Consumption Failed" && (
                    <button
                        className="btn text-light etr-btn bg-dark mx-auto rounded-pill d-block"
                        style={{ width: "150px" }} // Adjust width as needed
                        onClick={() => openEditModal(data)}
                    >
                        Edit
                    </button>
                )}
            </div>
        </div>
    );


    useEffect(() => {
        const fetchConsumptionstatus = async () => {
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestData = {
                    "Action": "getConsumptionstatus",
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "SrNumber": sessionStorage.getItem("ViewSR")
                    // "SrNumber": "SR22082532811"
                }
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });
                const result = await response.json();
                // console.log("result.Response", result.Response)
                if (result.Status == "1") {
                    setLoading(false);
                    setConsumStatus(result.Response)
                } else {
                    setLoading(false);
                    toast.warning(result.Message, {
                        position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                    });
                }
            } catch (error) {
                console.error("Error fetching ETR reasons:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchConsumptionstatus();
    }, []);



    useEffect(() => {
        const fetchGetMaterialConsumptionCRM = async () => {
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestData = {
                    "Action": "getMaterialConsumptionCRM",
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "CanId": sessionStorage.getItem("CanId"),
                    // "CanId": "9060885",

                    "Master": "false",
                    "SrNumber": sessionStorage.getItem("ViewSR")
                    // "SrNumber": "SR22082532811"

                }
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });
                const result = await response.json();
                // console.log("result.Response", result.Response)

                if (result.Status == "1") {
                    setLoading(false);
                    setConsumItem(result.Response)
                } else {
                    setLoading(false);
                    toast.warning(result.Message, {
                        position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                    });

                }
            } catch (error) {
                console.error("Error fetching ETR reasons:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchGetMaterialConsumptionCRM();
    }, []);

    const cardStyle = {
        backgroundColor: "#fff",
        padding: "1rem",
        marginBottom: "2rem",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
    };

    // useEffect(() => {
    //     const fetchMaterialConsumption = async () => {
    //         try {
    //             setLoading(true);
    //             const apiUrl = process.env.REACT_APP_API_URL;
    //             const requestData = {
    //                 Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
    //                 Action: "getMaterialconsumption",
    //                 // srNumber:  sessionStorage.getItem("ViewSR"),
    //                 // canID: sessionStorage.getItem("CanId"),
    //                 "canID": "188526",
    //                 "srNumber": "SR24092537278",

    //                 master: "false",
    //             };

    //             const response = await fetch(apiUrl, {
    //                 method: "POST",
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                 },
    //                 body: JSON.stringify(requestData),
    //             });

    //             const result = await response.json();
    //             console.log("API Response:", result);

    //             if (result.Status === "Success" && result.Response) {
    //                 // setMaterialConsumptionData(result.Response);
    //             } else {
    //                 toast.warning(result.Message || "Failed to fetch data", {
    //                     position: toast.POSITION.BOTTOM_CENTER,
    //                     autoClose: 1500,
    //                 });
    //             }
    //         } catch (error) {
    //             console.error("Error fetching material consumption:", error);
    //             toast.error("Error fetching data", {
    //                 position: toast.POSITION.BOTTOM_CENTER,
    //                 autoClose: 1500,
    //             });
    //         } finally {
    //             setLoading(false);
    //         }
    //     };

    //     fetchMaterialConsumption();
    // }, []);


    const [popupVisible, setPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");

    const handleEdit = (row) => {
        setSelectedRow(row);
        // Pre-fill the fields if available.
        setEditForm({
            quantity: row.Quantity || "",
            serialNo: Array.isArray(row.SerialNo)
                ? row.SerialNo.length > 0
                    ? row.SerialNo.join(", ")
                    : ""
                : row.SerialNo || ""
        });
        setShowEditModal(true);
    };

    // Handle changes for the edit form.
    const handleChange1 = (e) => {
        const { name, value } = e.target;
        setEditForm((prev) => ({ ...prev, [name]: value }));
    };

    // When Update is clicked in the modal.
    const handleUpdate1 = async () => {
        if (!selectedRow) return;
        try {
            const apiUrl = process.env.REACT_APP_API_URL;

            const adapterMap = {
                "Yes": "111260000",
                "No": "111260001",
            };

            const reasonMap = {
                "Faulty": "111260000",
                "Replace": "111260001",
                "Deactivate": "111260002",
                "NA": "111260003",
            };
            const payload = {
                Action: "editItemCRM",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                ItemID: selectedRow.ItemconsumptionID, // from row
                SerialNumber: editForm.serialNo,       // from input
                Quantity: editForm.quantity,           // from input
                LocationCode: selectedRow.LocationCode, // from row
                Adapter: adapterMap[selectedRow.Adapter] || selectedRow.Adapter,
                Reasonofreplacement: reasonMap[selectedRow.ReasonofReplacement] || selectedRow.ReasonofReplacement,
                // Adapter: "111260000",          // from row
                // Reasonofreplacement: "111260000", // from row
                Oldfaultydevice: selectedRow.OldFaultyDeviceSerailNo,   // from row
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const result = await response.json();
            // console.log("editItemCRM response:", result);

            if (result.Status === "Success") {
                toast.success(result.Response.Message || "Updated successfully", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                setShowEditModal(false);
                window.location.reload();

                // navigate("/materialConsumeStatus");
                // Optionally refresh table data here if needed.
            } else {
                toast.warning(result.Response?.Message || "Failed to update", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
        } catch (error) {
            console.error("Error updating item:", error);
            toast.error("Error updating item", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
    };



    // useEffect(() => {
    //     const callApprovalAPI = async () => {
    //         try {
    //             const apiUrl = process.env.REACT_APP_API_URL;
    //             const requestData = {
    //                 Action: "getsubmitApprovalERP",
    //                 Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
    //                 srNumber: sessionStorage.getItem("ViewSR"),
    //                 // "srNumber": "SR24042534758",

    //                 password: "Spectr@man#23!",
    //                 userName: "manager1",
    //             };

    //             const response = await fetch(apiUrl, {
    //                 method: "POST",
    //                 headers: { "Content-Type": "application/json" },
    //                 body: JSON.stringify(requestData),
    //             });

    //             const result = await response.json();
    //             console.log("Approval API result:", result);

    //             if (
    //                 result.Status === "Success" &&
    //                 result.Response &&
    //                 result.Response.DoaFlag === "true"
    //             ) {
    //                 setPopupMessage(result.Response.Message);
    //                 setPopupVisible(true);
    //             }
    //         } catch (error) {
    //             console.error("Error calling approval API:", error);
    //             toast.error("Error calling approval API", {
    //                 position: toast.POSITION.BOTTOM_CENTER,
    //                 autoClose: 1500,
    //             });
    //         }
    //     };

    //     callApprovalAPI();
    // }, []);


    // const handleEdit = (row) => {
    //     console.log("Edit clicked for row:", row);
    //     toast.info(`Edit clicked for ${row.Itemcode}`);
    //     // Implement further edit logic here, e.g. navigating to an edit form.
    //   };

    const handleSubmitApproval = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
                Action: "submitForApprovalERP",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                srNumber: sessionStorage.getItem("ViewSR"),
                // "srNumber": "SR22082532811",
                // password: "123456",
                // userName: "ravi.kumar4",
                password: sessionStorage.getItem("password"),
                userName:  sessionStorage.getItem("userName"),
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            // console.log("submitForApprovalERP response:", result);

            if (
                result.Status === "Success" &&
                result.Response &&
                result.Response.StatusName === "Success"
            ) {
                toast.success(result.Response.Message || "Submitted for Approval", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                setPopupVisible(false);
            } else {
                toast.warning(result.Response?.Message || "Failed to submit for approval", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
        } catch (error) {
            console.error("Error in submitForApprovalERP API:", error);
            toast.error("Error in submitting for approval", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
    };
    const handleIconClick = (formId) => {
        setActiveForm((prevActiveBox) =>
            prevActiveBox === formId ? null : formId
        );
    };
    const style = {
        control: (base) => ({
            ...base,
            border: 0,
            // Remove box shadow
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "black",
        }),
        inputFocused: {
            boxShadow: "none",
            fontSize: "14px",
        },
    };

    const modalStyles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
        },
        modal: {
            backgroundColor: "#fff",
            padding: "2rem",
            borderRadius: "8px",
            textAlign: "center",
            minWidth: "300px",
        },
    };

    // Helper function to render a dynamic table given an array of objects and a title.
    const renderTable = (dataArray, title) => {
        if (!dataArray || dataArray.length === 0) {
            return <p>No data available for {title}.</p>;
        }

        // Extract column headers from the keys of the first object.
        const headers = Object.keys(dataArray[0]);

        return (
            <div style={cardStyle}>
                <h3 style={{ marginBottom: "1rem" }}>{title}</h3>
                <div style={{ overflowX: "auto" }}>
                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        <thead>
                            <tr>
                                {headers.map((header) => (
                                    <th
                                        key={header}
                                        style={{
                                            border: "1px solid #ddd",
                                            padding: "8px",
                                            backgroundColor: "#f2f2f2",
                                        }}
                                    >
                                        {header}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {dataArray.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {headers.map((header) => (
                                        <td key={header} style={{ border: "1px solid #ddd", padding: "8px" }}>
                                            {row[header] !== null ? row[header].toString() : ""}
                                        </td>
                                    ))}
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                        {row.ItemStatus === "Consumption Failed" && (
                                            <button onClick={() => handleEdit(row)}>Edit</button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };


    return (
        <>
            {/* ************************header*********************** */}
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">

                    <span className="p-1 m-3">SR Details</span>
                </div>
            </div>



            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={masterStatus !== "Pending" ? redirectFaultRepairAssignments : redirectYourAssignmentAddItem}
                    >
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className="p-1 m-3 h4">Material Consumption</span>
                </div>
                <div className="container-fluid">
                    <ul className="nav nav-tabs">
                        <li className="nav-item">
                            <a className="nav-link active" data-bs-toggle="tab" href="#itemsTab">
                                Items
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" data-bs-toggle="tab" href="#equipmentTab">
                                Equipment
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="tab-content tab-main-content">
                <div className="tab-pane fade show active" id="itemsTab">
                    {loading ? (
                        <div className="loader-wrapper">
                            <div className="loader">
                                <img src={loader} alt="loading..." />
                            </div>
                        </div>
                    ) : (
                        <div className="container-fluid">
                            <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                                {items.map((item, index) => (
                                    <div className="col" key={index}>
                                        {renderCard(item)}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
                <div className="tab-pane fade" id="equipmentTab">
                    {loading ? (
                        <div className="loader-wrapper">
                            <div className="loader">
                                <img src={loader} alt="loading..." />
                            </div>
                        </div>
                    ) : (
                        <div className="container-fluid">
                            <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                                {equipment.map((eq, index) => (
                                    <div className="col" key={index}>
                                        {renderCard(eq)}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Edit Modal */}
            <Modal show={editModal} onHide={() => setEditModal(false)}>
                <Modal.Header closeButton style={{ backgroundColor: '#9465aa' }}>
                    <Modal.Title style={{ color: '#ffffff' }}>Edit Item</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="container-fluid" >

                        {/* **************Installation Address toggle******************* */}
                        {/* <div
                            className="Installation-toggle mt-3"
                            onClick={() => handleIconClick("form3")}
                        >
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div> */}

                        {/* {activeForm === "form3" && ( */}
                        <div
                            className=" container shadow mb-3 bg-body rounded mt-4"
                        // id="form3"
                        >
                            {/**********Installation Address form******** */}
                            <form className="Installation-form p-2" onSubmit={handleUpdate}>




                                {/* <form
                            className=" container shadow mb-3 bg-body rounded mt-4"

                            onSubmit={handleUpdate}> */}
                                <div>
                                    <label className="select-search-label mt-2">Item</label>
                                    <Select
                                        className=" basic-single form-control form-control-sm  p-1"
                                        classNamePrefix="select"
                                        name="item"
                                        placeholder="Select Item"
                                        styles={style}
                                        isSearchable={false}
                                        value={selectedItem}
                                        onChange={handleItem}
                                        options={optionItem.map((data) => ({
                                            value: data.item_code,
                                            label: data.item_name,
                                        }))}
                                    />
                                </div>
                                <div>
                                    <label className="select-search-label mt-2">Sub Item</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="subItem"
                                        placeholder="Select Sub Item"
                                        styles={style}
                                        isSearchable={false}
                                        value={selectedSubItem}
                                        onChange={handleSubItem}
                                        options={optionSubItem.map((data) => ({
                                            value: data.sub_item_code,
                                            label: data.sub_item_name,
                                        }))}
                                    />
                                </div>
                                <div className="input-box form-floating">
                                    <input
                                        type="tel"
                                        placeholder=""
                                        className="form-control input-text form-control-sm mt-1"
                                        id="quantity"
                                        name="quantity"
                                        value={addItemData.quantity}
                                        onChange={handleChange}
                                        onKeyDown={(e) => {
                                            const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
                                            const isDigit = /\d/.test(e.key);
                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                return true;
                                            } else {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    <label htmlFor="quantity" className="mt-2">
                                        Quantity
                                    </label>
                                </div>
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder=""
                                        className="form-control input-text form-control-sm mt-1"
                                        id="serialNo"
                                        name="serialNo"
                                        value={addItemData.serialNo}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="serialNo" className="mt-2">
                                        Serial No./Lot No.
                                    </label>
                                </div>
                                <div className="mt-3">
                                    <label className="select-search-label mt-2">Adaptor</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="adaptor"
                                        placeholder="Select Adaptor"
                                        styles={style}
                                        isSearchable={false}
                                        value={adaptor}
                                        onChange={handleAdaptor}
                                        options={[
                                            { value: "111260000", label: "Yes" },
                                            { value: "111260001", label: "No" },
                                        ]}
                                    />
                                </div>
                                <div className="mt-3">
                                    <label className="select-search-label mt-2">Reason of Replacement</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="reasonOfReplacement"
                                        placeholder="Select Reason of Replacement"
                                        styles={style}
                                        isSearchable={false}
                                        value={reasonOfReplacement}
                                        onChange={handleReasonOfReplacement}
                                        options={[
                                            { value: "111260000", label: "OFC Cable Port Damage" },
                                            { value: "111260001", label: "Device Faulty - Fan Failure" },
                                            { value: "111260002", label: "Device Faulty - Port damage - LAN Output" },
                                            { value: "111260003", label: "Device Faulty - No Power on device" },
                                            { value: "111260004", label: "Device Faulty - Physical damage/Burnt" },
                                            { value: "111260005", label: "Device Faulty - Voltage fluctuations" },
                                            { value: "111260006", label: "Device Faulty - Overheating" },
                                            { value: "111260007", label: "Environmental issue - temperature extremes" },
                                            { value: "111260008", label: "Environmental issue - Dust and Dirt accumulation" },
                                            { value: "111260009", label: "Inappropriate Voltage Adapter - Improper power supply" },
                                            { value: "111260010", label: "Power Adapters Faulty - Burnt / Damage" },
                                            { value: "111260011", label: "Software Issue - Firmware issue/Software Bugs and malware" },
                                            { value: "111260012", label: "Software Issue - Configuration issue" },
                                            { value: "111260013", label: "Software Issue - IP configuration issue" },
                                            { value: "111260014", label: "Software Issue - MAC Authentication issue" },
                                            { value: "111260015", label: "Wi-Fi Range issue" },
                                            { value: "111260016", label: "Device working replaced due to customer consent" },
                                            { value: "111260017", label: "Device working replaced due to NOC recommendation" }
                                        ]}
                                    />
                                </div>
                                <div className="input-box form-floating mt-3">
                                    <input
                                        type="text"
                                        placeholder=""
                                        className="form-control input-text form-control-sm mt-1"
                                        id="FaultyDevice"
                                        name="FaultyDevice"
                                        value={addItemData.FaultyDevice}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="FaultyDevice" className="mt-2">
                                        Old Faulty Device Serial No
                                    </label>
                                </div>
                                <div className="mt-3">
                                    <label className="select-search-label mt-2">Store</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="locationCode"
                                        placeholder="Select Store"
                                        styles={style}
                                        isSearchable={false}
                                        value={locationCode}
                                        onChange={handleLocationChange}
                                        options={locationOptions.map((data) => ({
                                            value: data.Value,
                                            label: data.Text,
                                        }))}
                                    />
                                </div>
                                <div className="text-center mt-5 mb-2">
                                    <button
                                        type="submit"
                                        className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
                                    >
                                        Update
                                    </button>
                                </div>
                                {/* </form> */}
                            </form>
                        </div>

                        {/* )} */}
                    </div>
                </Modal.Body>
            </Modal>


            {/* *************************header End*********************** */}


            {loading ? (
                <div className="loader-wrapper">
                    <div className="loader">
                        <img src={loader} alt="loading...."></img>
                    </div>
                </div>
            ) : (
                <div className="container-fluid" style={{ marginTop: "65px" }}>

                    <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                        {/* Check if consumItem is an object and consumStatus is an array */}
                        {consumItem && Array.isArray(consumStatus) && consumStatus.length > 0 ? (
                            consumStatus.map((item, statusIndex) => (
                                <div className="col" key={statusIndex}>
                                    <div className="card mb-3">
                                        <div className="p-2 card-data">
                                            <div>
                                                <div className="assignment-card">
                                                    <div className="row">
                                                        <div className="col-5 text-weight-color">Consumption Status</div>
                                                        <div className="col-1">:</div>
                                                        <div className="col-6">{item.approvalstatus || 'N/A'}</div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-5 text-weight-color">Status</div>
                                                        <div className="col-1">:</div>
                                                        <div className="col-6">{item.Frstatus || 'N/A'}</div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-5 text-weight-color">Item Name</div>
                                                        <div className="col-1">:</div>
                                                        {/* If item is null, show "N/A" or a default value */}
                                                        {/* <div className="col-6">{consumItem.item || 'N/A'}</div> */}
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-5 text-weight-color">Sub Item Name</div>
                                                        <div className="col-1">:</div>
                                                        {/* If equipment is null, show "N/A" or a default value */}
                                                        {/* <div className="col-6">{consumItem.equipment || 'N/A'}</div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div>No data available</div>
                        )}
                    </div>


                    {showEditModal && (
                        <div style={modalStyles.overlay}>
                            <div style={modalStyles.modal}>
                                <h3>Edit Item</h3>
                                {/* Quantity Field */}
                                <div className="input-box form-floating">
                                    <input
                                        type="tel"
                                        placeholder=""
                                        className="form-control input-text form-control-sm mt-1"
                                        id="quantity"
                                        name="quantity"
                                        value={editForm.quantity}
                                        onChange={handleChange}
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                            ];
                                            const isDigit = /\d/.test(e.key);
                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                return true;
                                            } else {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    <label htmlFor="quantity" className="mt-2">
                                        Quantity
                                    </label>
                                </div>

                                {/* Serial No./Lot No. Field */}
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder=""
                                        className="form-control input-text form-control-sm mt-1"
                                        id="serialNo"
                                        name="serialNo"
                                        value={editForm.serialNo}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="serialNo" className="mt-2">
                                        Serial No./Lot No.
                                    </label>
                                </div>

                                {/* Update and Cancel Buttons */}
                                <button onClick={handleUpdate}
                                    className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
                                    style={{ marginTop: "1rem" }}>
                                    Update
                                </button>
                                <button
                                    onClick={() => setShowEditModal(false)}
                                    className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
                                    style={{ marginTop: "1rem", marginLeft: "1rem" }}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    )}
                    <div className=" text-center mt-5 mb-2">
                        {masterStatus === "Pending" && (

                            <button
                                type="submit"
                                className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
                                onClick={handleMaterialConsumeNext}
                            >
                                Next
                            </button>)}

                        <>
                            {popupVisible && (
                                <div style={modalStyles.overlay}>
                                    <div style={modalStyles.modal}>
                                        <p>{popupMessage}</p>
                                        <button
                                            type="submit"
                                            className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
                                            onClick={handleSubmitApproval}>
                                            Submitted for approval
                                        </button>
                                    </div>
                                </div>
                            )}
                        </>

                    </div>
                </div>
            )}



            {/* ***********************  Add Icon************************** */}
            {masterStatus === "Pending" && (
                <div className='position-fixed bottom-0 end-0 m-4' onClick={redirectYourAssignmentAddItem}>
                    <span className='bg-dark rounded-circle faPlus-icon'>
                        <i className="fa-solid fa-plus fa-lg text-light m-1"></i>
                    </span>
                </div>
            )}
        </>
    )
}

export default MaterialConsumeStatus